<div class="landing-earn-wrapper">
  <div class="landing-earn-content">
    <h2 class="landing-earn-header">{{ 'eat_and_win_with_box' | translate }}</h2>
    <h2 class="landing-earn-header">{{ 'always_' | translate }}.</h2>
    <div class="landing-earn-text-container">
      <p class="landing-earn-text">
        {{ 'yes_we_are_not_exaggerating' | translate }}
      </p>
      <p class="landing-earn-text" [innerHTML]="'because_with_every_order_points_coming' | translate | safeHtml"></p>
    </div>
    <a class="landing-earn-link" (click)="onShowVideo()">
      <figure class="landing-earn-link-figure">
        <img src="/assets/images/landing/earn/landing-earn-play-icon.svg" [attr.alt]="'see_here_how' | translate" />
      </figure>
      <div class="landing-earn-link-text-container">
        <span class="landing-earn-link-text">{{ 'delivery_where_you_always_win' | translate }}</span>
        <span>{{ 'see_the_video' | translate }}</span>
      </div>
    </a>
  </div>
  <div class="landing-earn-image-wrapper">
    <picture class="landing-earn-image">
      <source type="image/webp" [srcset]="webpSrcSet" alt="Brunch" />
      <source type="image/png" [srcset]="pngSrcSet" alt="Brunch" />
      <img [src]="imagePng3" [srcset]="pngSrcSet" alt="Brunch" />
    </picture>
  </div>
</div>
